<template>
  <v-app-bar v-if="!isIframe" app>
    <h1>{{ accountname }}</h1>
    <v-spacer />
    <locale-switcher />
    <v-menu v-if="$store.getters.currentUserProfile" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="blue" v-bind="attrs" v-on="on">
            <v-icon color="white" class="mr-2">
mdi-account-circle
</v-icon>{{ displayName }}
        </v-btn>
      </template>
      <user-profile-selection mini />
    </v-menu>

    <div class="popups">
      <notification-alert v-bind="teamWork" @closed="closeModal()" />
    </div>
  </v-app-bar>
</template>

<script>

  import 'firebase/auth'
  import UserProfileSelection from '@/views/components/UserProfileSelection'
  import LocaleSwitcher from '@/views/components/LocaleSwitcher'
  import NotificationAlert from '@/components/NotificationAlert.vue'
  import store from '../../store'
  import { cookies } from '@/util/cookies'

  export default {
    name: 'PagesCoreAppBar',
    components: {
      NotificationAlert,
      'locale-switcher': LocaleSwitcher,
      'user-profile-selection': UserProfileSelection,
    },
    data () {
      return {
        isIframe: process.env.VUE_APP_IS_IFRAME && process.env.VUE_APP_IS_IFRAME === 'true',
        teamWork: {
          isVisible: false,
          title: 'New Module: Increasing Immunization Confidence',
          imageUrl: 'https://firebasestorage.googleapis.com/v0/b/bodyswaps-experimental/o/images%2FIncreasing%20Immunization%20Confidence%20Def.png?alt=media&token=500e7a99-a4ba-4e65-a3b2-d32deb86faab',
          link: {
            url: 'https://bodyswaps.co/soft-skills-training-in-vr/healthcare/increasing-immunization-confidence',
            label: 'Learn More',
          },
          content: [
            {
              contentType: 'p',
              content: 'Empower your healthcare staff with the confidence to engage in immunization conversations with patients and families.',
            },
            {
              contentType: 'p',
              content: [
                {
                  text: 'Increasing Immunization Confidence gives learners a psychologically safe space to work through scenarios with vaccine-hesitant parents to build the skills necessary to have confident conversations.',
                },
              ],
            },
            {
              contentType: 'p',
              content: [
                {
                  text: 'Available Now.*',
                },
              ],
            },
            {
              contentType: 'p',
              content: [
                {
                  text: '*Interested in this module? Access it for free by heading to the webpage by clicking ‘Learn more’.',
                  style: 'font-size: 12px;',
                },
              ],
            },
          ],
        },
      }
    },
    computed: {
      displayName () {
        const loggedUser = this.$store.getters.currentUserProfile.user
        return loggedUser.email
      },
      accountname () {
        return this.$store.getters.userName
      },
    },

    mounted () {
      const seenPopup = cookies.get('seenPopup1')
      if (!seenPopup && store.getters.userHasRole('admin')) {
        setTimeout(() => {
          this.teamWork.isVisible = true
        }, 1000)
      }
    },

    methods: {
      closeModal () {
        cookies.set('seenPopup1', 'yes')
        this.teamWork.isVisible = false
      },
    },
  }
</script>

<style scoped>
</style>
